import { render } from "./FilterEnrolleeComponent.vue?vue&type=template&id=606af72a"
import script from "./FilterEnrolleeComponent.vue?vue&type=script&lang=js"
export * from "./FilterEnrolleeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__